import type { Category } from '@wix/ambassador-funnel-intro-v1-intro-data/types'
import type { BusinessTerm } from '@wix/ambassador-funnel-taxonomy-v1-business-term/types'

import { defaultCategory } from './defaultCategory'

export const resolveCategoryFromBusinessTerm = (
  businessTerm?: BusinessTerm | null,
  businessSegmentId?: string,
): Required<Category> => {
  if (!businessTerm) {
    return defaultCategory
  }
  const { displayName, industryId, structureId, businessTermId = '', postRegVertical } = businessTerm
  if (!displayName || !industryId || !structureId) {
    return defaultCategory
  }
  return {
    displayName,
    industryId,
    structureId,
    businessTermId,
    businessSegmentId: businessSegmentId || 'not-classified',
    postRegVertical: postRegVertical || 'unknown',
    isDefault: false,
  }
}
